import { Stack } from '@mui/material';
import { ScreenHeaderStatusCollapse, ScreenHeaderTagConfig } from '../screenHeader.types';
import { ScreenHeaderTag } from './ScreenHeaderTag';

interface ScreenHeaderStatusProps {
  tags?: ScreenHeaderTagConfig[];
  collapse?: ScreenHeaderStatusCollapse;
}

const isTagCollapsed = (collapse: ScreenHeaderStatusCollapse, index: number) => {
  if (collapse === 'all') {
    return true;
  }

  return collapse === 'secondary' && index > 0;
};

export const ScreenHeaderStatus = ({ tags, collapse = 'none' }: ScreenHeaderStatusProps) => {
  if (!tags?.length) {
    return null;
  }

  return (
    <Stack direction="row" sx={{ alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
      {tags.map((tag, index) => (
        <ScreenHeaderTag
          key={`${tag.label}-${index}`}
          {...tag}
          isCollapsed={isTagCollapsed(collapse, index)}
        />
      ))}
    </Stack>
  );
};
